/*
 * @Descripttion:组件顶部小标题 
 * @version: 
 * @Author: xutingting
 * @Date: 2021-04-12 11:27:16
 * @LastEditors: xutingting
 * @LastEditTime: 2021-12-02 10:11:44
 */
import React from 'react';

const TopTitle = (props) =>{
  const { title } = props;
  return (
    <div style={{display:'flex',marginBottom:'12px'}}>
      <div style={{width:3,height:16,backgroundColor:'#3399FF',marginRight:'8px'}}></div>
      <div style={{fontSize:'16px',color: '#333333',fontWeight: 500, lineHeight:'16px'}}>{title}</div>
    </div>
  );
}

export default TopTitle;